import React from 'react'
import { isString } from 'libraries/lodash'
import ellipsis from 'text-ellipsis'
import TableCell from 'components/dealwatch/TableCell'
import ParameterComment from 'pages/mwdealdetails/ParameterComment'

const ParamTableCell = ({ paramName, deal, formatted }) => {
  if (paramName === null) {
    return <TableCell>&nbsp;</TableCell>
  }
  const displayValue = isString(formatted) ? ellipsis(formatted, 35) : formatted || '-'
  const hoverValue = (isString(formatted) && (displayValue.length < formatted.length)) ? formatted : undefined
  const comment = deal.comments[paramName]

  return (
    <TableCell data-hover-popover-content={hoverValue}>
      <div className='min-w12 flex justify-between max-h7 o-auto'>
        <span class='flex items-center'>{isString(formatted) ? ellipsis(formatted, 35) : formatted || '-'}</span>
        {comment && <ParameterComment comment={comment.value} />}
      </div>
    </TableCell>
  )
}

export default ParamTableCell
